import { render, staticRenderFns } from "./classical-information-category-form.vue?vue&type=template&id=85bc2986"
import script from "./classical-information-category-form.vue?vue&type=script&lang=js"
export * from "./classical-information-category-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports